module.exports = {"audiences":["englishMembers","alphaEnglishMembers"],"experimentVersion":"v1","bucketVersion":"v1","experimentAllocation":{"englishMembers":0,"alphaEnglishMembers":0},"defaultWeight":1,"defaults":{"tabbed":false},"autoTrack":true,"variations":[{"name":"tabbed","weight":1,"values":{"tabbed":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/tabbedBoardMenu.json
// module id = vSXd
// module chunks = 0